module.exports = __webpack_public_path__ + "img/hr-garballo-16.4800c150.png";